import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GetPageQuery {
  private apiUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {}

  execute(page_id: string): Observable<any> {
    return this.http.post(this.apiUrl,
      {query:
          `query get_page {
            page(where: {id: "${page_id}"}) {
              id
              title
              content {
                html
              }
            }
          }`
      });
  }
}
